const apiURLBuilder = require('../core/apiURLBuilder');
const Api = require('../services/api');
const actionTypes = require('constants/actionTypes');
const formActions = require('react-redux-form').actions;
const Storage = require('utilities/storage');
const { ALLOW_COOKIE } = require('constants/index');

const changeTimeLeft = data => {
    return {
        type: actionTypes.CHANGE_TIME_LEFT,
        data,
    };
};

const errorInResponse = () => {
    return {
        type: actionTypes.ERROR_IN_RESPONSE,
    };
};

const updateRenewStatus = data => {
    return {
        type: actionTypes.RENEW_STATUS,
        data,
    };
};

const closeByNewLogin = () => {
    return {
        type: actionTypes.CLOSED_BY_NEW_LOGIN,
    };
};

const logoutService = (dispatch, accessToken) => {
    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
    };
    Api.post(apiURLBuilder.getURL('logout'), requestData);
};

const checkSessionTimeLeft = (dispatch, accessToken) => {
    Api.get(apiURLBuilder.getURL('getSessionTimeLeft', { access_token: accessToken })).then(
        response => {
            if (response.body) {
                const data = response.body;
                dispatch(changeTimeLeft(data));
            }
        },
        () => {
            dispatch(errorInResponse());
        }
    );
};

const renewSessionTime = (dispatch, refreshToken) => {
    Api.get(apiURLBuilder.getURL('getSessionRenew', { refresh_token: refreshToken })).then(
        response => {
            if (response.body) {
                const data = response.body;
                dispatch(formActions.change('userProfile.accessToken', data.accessToken));
                dispatch(formActions.change('userProfile.refreshToken', data.refreshToken));

                if (ALLOW_COOKIE) {
                    const expires = new Date(new Date().getTime() + 45 * 60 * 1000);
                    Storage.cookies.set('accessToken', data.accessToken, { expires });
                    Storage.cookies.set('refreshToken', data.refreshToken, { expires });
                }

                dispatch(updateRenewStatus(data));
            }
        },
        error => {
            if (error.body.errors['session.closedByNewLogin']) {
                dispatch(closeByNewLogin());
            } else {
                dispatch(errorInResponse());
            }
        }
    );
};

const logout = accessToken => {
    return dispatch => {
        logoutService(dispatch, accessToken);
    };
};

const checkSession = accessToken => {
    return dispatch => {
        checkSessionTimeLeft(dispatch, accessToken);
    };
};

const renewSession = accessToken => {
    return dispatch => {
        renewSessionTime(dispatch, accessToken);
    };
};

export default {
    logout,
    checkSession,
    renewSession,
};
